module.exports = __webpack_public_path__ + "images/plus-53a904156d1635a36d97fb0226de4921.png";